<template>
    <div class="originalReading-view" @click="showCateLog = false">
        <div ref="bodyMask"
             :style="{width: `${ bodyMaskWidth }px`}"
             class="originalReading-body-mask">
            <div ref="groupsTotalWrapper"
                 class="groups-total-wrapper"
                 @mousedown.stop.prevent="imgGroupsWrapperMouseDown"
                 @mousemove.stop.prevent="imgGroupsWrapperMouseMove"
                 @mouseup.stop.prevent="imgGroupsWrapperMouseUp"
                 @mouseleave.stop.prevent="imgGroupsWrapperMouseUp">
                <div :style="{ transform: openEnlarge ? `scale(${enlargeScale})` : '',
                               transform: groupsTotalTransform}"
                     class="groups-total-mask">
                    <div ref="leftGroups"
                         :style="{width: `${ itemWidth }px`,
                                  height:`${ itemHeight }px`}"
                         class="img-groups-mask">
                        <img v-for="(item,index) in leftImgsArr"
                             :style="{width: (index + 1) % 4 === 0 ? '12%' : '29%',
                                      opacity: item ? '' : 0,
                                      height: index <= 15 ? '22.4%' : '10.4%'}"
                             :key="index"
                             :src="item">
                    </div>
                    <div v-if="showNextImgs"
                         ref="rightGroups"
                         :style="{width: `${ itemWidth }px`,
                                  height:`${ itemHeight }px`}"
                         class="img-groups-mask">
                        <img v-for="(item,index) in rightImgsArr"
                             :style="{width: (index + 1) % 4 === 0 ? '12%' : '29%',
                                      opacity: item ? '' : 0,
                                      height: index <= 15 ? '22.4%' : '10.4%'}"
                             :key="index"
                             :src="item">
                    </div>
                </div>
            </div>
            <div :style="{width: `${ showNextImgs ? itemWidth * 2 : itemWidth }px`,
                          left: `${ positionLeftRight }px`,
                          bottom: '25px' }"
                 class="progress-mask">
                <div :style="{width: `${percentBarWidth}%`}" class="percent-mask"/>
            </div>
            <div class="active-btns">
                <div class="base-btn back-btn" @click="closeWindow"/>
                <div class="base-btn fullScreen-btn" @click="fullScreenClick"/>
                <div class="base-btn enlarge-btn"
                     @click="enlargeClick"/>
                <div class="base-btn ensmall-btn"
                     @click="ensmallClick"/>
                <div :style="{'backgroundImage':showCateLog ?
                                  `url('${require('@//assets/originalReader/catelogBase.png')}')` :
                                  `url('${require('@//assets/originalReader/catelog.png')}')`,
                              backgroundColor: showCateLog ? '#51abff': '#fff' }"
                     class="base-btn catelog-btn"
                     @click.stop="showCateLog = !showCateLog;"/>
                <div :style="{'backgroundImage':readingPageIndex <= 2 ?
                         `url('${require('@//assets/originalReader/prevDisable.png')}')` :
                     `url('${require('@//assets/originalReader/prev.png')}')` }"
                     class="page-btn prev-btn"
                     @click="switchPage('prev')"/>
                <div :style="{'backgroundImage':readingPageIndex >= totalCount - 1 ?
                         `url('${require('@//assets/originalReader/prevDisable.png')}')` :
                     `url('${require('@//assets/originalReader/prev.png')}')` }"
                     class="page-btn next-btn"
                     @click="switchPage('next')"/>
            </div>
            <div :style="{width: showCateLog ? `${ catelogMaskWidth }px` : '0',
                          right: `${ positionLeftRight }px`,
                          height:`${ itemHeight }px`}"
                 class="catelog-mask">
                <div ref="catelogWrapper"
                     :style="{width: showCateLog ? `${ catelogMaskWidth }px` : '0',
                              transition: showCateLog ? 'none' : 'width 0s .5s',
                              height:`${ itemHeight }px`}"
                     class="catelog-wrapper">
                    <div class="catelog-content">
                        <img v-for="(item,index) in originalCatelog"
                             :key="index"
                             :src="item"
                             @click="cateClick(index+2)">
                    </div>
                </div>
            </div>
        </div>
        <div :style="{opacity: isPending ? 1 : 0,zIndex: isPending ? '' : -1}"
             class="loader">
            <svg id="Layer_1"
                 version="1.1"
                 xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px"
                 y="0px"
                 width="72px"
                 height="90px"
                 viewBox="0 0 24 30"
                 style="enable-background:new 0 0 50 50;"
                 xml:space="preserve">
                <rect :fill="themeColor"
                      x="0"
                      y="10"
                      width="4"
                      height="10"
                      opacity="0.2">
                    <animate attributeName="opacity"
                             attributeType="XML"
                             values="0.2; 1; .2"
                             begin="0s"
                             dur="0.6s"
                             repeatCount="indefinite" />
                    <animate attributeName="height"
                             attributeType="XML"
                             values="10; 20; 10"
                             begin="0s"
                             dur="0.6s"
                             repeatCount="indefinite" />
                    <animate attributeName="y"
                             attributeType="XML"
                             values="10; 5; 10"
                             begin="0s"
                             dur="0.6s"
                             repeatCount="indefinite" />
                </rect>
                <rect :fill="themeColor"
                      x="8"
                      y="10"
                      width="4"
                      height="10"
                      opacity="0.2">
                    <animate attributeName="opacity"
                             attributeType="XML"
                             values="0.2; 1; .2"
                             begin="0.15s"
                             dur="0.6s"
                             repeatCount="indefinite" />
                    <animate attributeName="height"
                             attributeType="XML"
                             values="10; 20; 10"
                             begin="0.15s"
                             dur="0.6s"
                             repeatCount="indefinite" />
                    <animate attributeName="y"
                             attributeType="XML"
                             values="10; 5; 10"
                             begin="0.15s"
                             dur="0.6s"
                             repeatCount="indefinite" />
                </rect>
                <rect :fill="themeColor"
                      x="16"
                      y="10"
                      width="4"
                      height="10"
                      opacity="0.2">
                    <animate attributeName="opacity"
                             attributeType="XML"
                             values="0.2; 1; .2"
                             begin="0.3s"
                             dur="0.6s"
                             repeatCount="indefinite" />
                    <animate attributeName="height"
                             attributeType="XML"
                             values="10; 20; 10"
                             begin="0.3s"
                             dur="0.6s"
                             repeatCount="indefinite" />
                    <animate attributeName="y"
                             attributeType="XML"
                             values="10; 5; 10"
                             begin="0.3s"
                             dur="0.6s"
                             repeatCount="indefinite" />
                </rect>
            </svg>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import {magazineoriginalvisitLog,statistical} from '@/apis/src/statisti/magazine'
    export default {
        components: {
        },
        data () {
            return {
                catelogBScroll: null,
                bodyMaskHeight: 0,
                scales: {
                    maskW$maskH: 730 / 1024,
                    itemW$maskW: 630 / 730,
                    itemH$maskH: 924 / 1024,
                    cateW$maskW: 260 / 730,
                    padding2Num: 100
                },
                showNextImgs: false,
                showCateLog: false,
                readingPageIndex: 2,
                lastParams: {},
                originalImgsArrBase: [],
                originalCatelog: [],
                isFullScreen: false,
                isPending: false,
                openEnlarge: true,
                showScaleGlass: false,
                totalCount: 0,
                enlargeScale: 1,
                enlargeTimes:0.5,
                mouseEventObj: {
                    isPressing: false,
                    startX: undefined,
                    startY: undefined

                },
                enlargePos: {
                    x: 0,
                    y: 0
                },
                showLoading: false,
                statisticalinst:new statistical,
                magazineoriginalvisitLoginst:new magazineoriginalvisitLog,
                magazineInfo:{}
            }
        },
        computed: {
            bodyMaskWidth () {
                const { bodyMaskHeight, scales } = this
                const { maskW$maskH, padding2Num } = scales
                const windowWidth = document.body.clientWidth
                const newWidth = bodyMaskHeight * maskW$maskH
                if (newWidth > 0 && windowWidth > (newWidth * 2 + padding2Num * 2)) {
                    this.setShowNextImgs(true)
                    return newWidth * 2 - 100
                }
                this.setShowNextImgs(false)
                return newWidth
            },
            itemWidth () {
                const { showNextImgs, bodyMaskWidth, scales } = this
                const { itemW$maskW, padding2Num } = scales
                if (showNextImgs) {
                    const oneWith = (bodyMaskWidth + padding2Num) / 2
                    return oneWith * itemW$maskW
                }
                return bodyMaskWidth * itemW$maskW
            },
            itemHeight () {
                const { bodyMaskHeight, scales } = this
                const { itemH$maskH } = scales
                return bodyMaskHeight * itemH$maskH
            },
            positionLeftRight () {
                const { bodyMaskWidth, itemWidth, showNextImgs } = this
                if (showNextImgs) {
                    return (bodyMaskWidth - (itemWidth * 2)) / 2
                }
                return (bodyMaskWidth - itemWidth) / 2
            },
            catelogMaskWidth () {
                const {
                    bodyMaskWidth, showNextImgs, scales, catelogBScroll
                } = this
                this.setCatelogMaskTransition(false)
                this.$nextTick(() => {
                    if (catelogBScroll) {
                        catelogBScroll.refresh()
                        this.setCatelogMaskTransition(true)
                    }
                })
                if (showNextImgs) {
                    return (bodyMaskWidth / 2) * scales.cateW$maskW
                }
                return bodyMaskWidth * scales.cateW$maskW
            },
            leftImgsArr () {
                const {
                    readingPageIndex, originalImgsArrBase, isPending, showNextImgs
                } = this
                let arrIndex
                if (showNextImgs) {
                    if (readingPageIndex % 2 === 0) {
                        arrIndex = readingPageIndex - 1
                    } else {
                        arrIndex = readingPageIndex - 2
                    }
                } else {
                    arrIndex = readingPageIndex - 1
                }

                if (originalImgsArrBase[arrIndex]) {
                    return originalImgsArrBase[arrIndex]
                }
                if (!isPending) {
                    this.getOriginalImgs(readingPageIndex)
                }
                return []
            },
            rightImgsArr () {
                const { readingPageIndex, originalImgsArrBase, showNextImgs } = this
                if (!showNextImgs) {
                    return []
                }
                let arrIndex
                if (readingPageIndex % 2 === 0) {
                    arrIndex = readingPageIndex
                } else {
                    arrIndex = readingPageIndex - 1
                }

                if (originalImgsArrBase[arrIndex]) {
                    return originalImgsArrBase[arrIndex]
                }
                return []
            },
            percentBarWidth () {
                const { readingPageIndex, totalCount, showNextImgs } = this
                let num = readingPageIndex
                if (showNextImgs) {
                    num += 1
                }
                return num / (totalCount - 1) * 100
            },
            themeColor () {
                // return this.$store.state.themeColor
                return '#20A0FF'
            },
            groupsTotalTransform () {
                const { openEnlarge, enlargeScale, enlargePos,enlargeorsmall } = this
                if (!openEnlarge) {
                    return ''
                }
                const {
                    x, y
                } = enlargePos;
                return `translate( ${ x }px, ${ y }px) scale(${ enlargeScale }) `
                /*if(enlargeorsmall=='large'){
                    
                }else{
                    enlargePos.x = 0;
                    enlargePos.y= 0 ;
                    console.log('bb')
                    return `translate( 0px, 0px) scale(${ enlargeScale }) `
                }*/

            }
        },
        activated () {
            this.setBodyMaskHeight()
        },
        mounted () {
            this.initBScroll()
            this.watchWinodwResize()
        },
        methods: {
            resetenlargeScale(){
                this.enlargeScale=1;
                this.enlargePos.x = 0;
                this.enlargePos.y = 0;
            },
            getMagainzeInfo(params)
            {
                return new Promise(async (resolve,reject) => {
                    const { id, year, issue } = params;
                    let { Data } =await this.$apis('magazine').getDetailInfo(id, year, issue);
                   this.magazineInfo = Data;
                   resolve(1)
                })
            },
            closeWindow()
            {
               this.$router.go(-1)
                //window.close();
            },
            initBScroll () {
                this.$nextTick(() => {
                    this.catelogBScroll = new BScroll(this.$refs.catelogWrapper, {
                        bounce: false,
                        click: true,
                        pullUpLoad: {
                            threshold: 300
                        },
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                    this.catelogBScroll.on('pullingUp', () => {
                        try {
                            this.getOriginalCatelog()
                        } catch (error) {
                            console.log(error)
                        }
                    })
                })
            },
            setBodyMaskHeight () {
                const { bodyMask } = this.$refs
                this.bodyMaskHeight = bodyMask.clientHeight
            },
            watchWinodwResize () {
                const vm = this
                window.addEventListener('resize', () => {
                    vm.bodyMaskHeight -= 1
                    vm.setBodyMaskHeight()
                })
            },
            setShowNextImgs (bool) {
                if (this.showNextImgs === bool) {
                    return
                }
                this.showNextImgs = bool
            },
            setCatelogMaskTransition (bool) {
                this.hasCatelogMaskTransition = bool
            },
            switchPage (type) {
                
                const {
                    isPending, showNextImgs, totalCount
                } = this
                if (isPending) {
                    return
                }
                if (type === 'prev') {
                    if (showNextImgs) {
                        this.readingPageIndex -= 2
                    } else {
                        this.readingPageIndex -= 1
                    }

                    if (this.readingPageIndex < 2) {
                        this.readingPageIndex = 2
                    }
                }
                if (type === 'next') {
                    if (showNextImgs) {
                        this.readingPageIndex += 2
                    } else {
                        this.readingPageIndex += 1
                    }
                    if (this.readingPageIndex >= totalCount - 1) {
                        this.readingPageIndex = totalCount - 1
                    }
                }
                this.statisticalinst.startstatistical();
                this.magazineoriginalvisitLoginst.addvisitLog(this.magazineInfo.ID,this.magazineInfo.Name,this.magazineInfo.Year,this.magazineInfo.Issue,this.readingPageIndex,this.openEnlarge);
                this.resetenlargeScale()
            },
            enlargeClick () {
                this.enlargeScale+=this.enlargeTimes;
            },
            ensmallClick()
            {
                if(this.enlargeScale-this.enlargeTimes<=1)
                {
                    this.enlargeScale = 1;

                }else{
                    this.enlargeScale-=this.enlargeTimes;                    
                }
                this.postionEnLargePos();
            },
            postionEnLargePos()
            {
                const { groupsTotalWrapper } = this.$refs
                const midWidth = groupsTotalWrapper.clientWidth * ((this.enlargeScale - 1) / 2)
                const midHeight = groupsTotalWrapper.clientHeight * ((this.enlargeScale - 1) / 2)

                if (this.enlargePos.x <= -midWidth) {
                    this.enlargePos.x = -midWidth
                }
                if (this.enlargePos.x > midWidth) {
                    this.enlargePos.x = midWidth
                }
                if (this.enlargePos.y <= -midHeight) {
                    this.enlargePos.y = -midHeight
                }
                if (this.enlargePos.y > midHeight) {
                    this.enlargePos.y = midHeight
                }
            },
            fullScreenClick () {
                if (this.isFullScreen) {
                    this.exitFullScreen()
                } else {
                    this.setFullScreen()
                }
            },
            setFullScreen () {
                const el = document.documentElement
                const rfs = el.requestFullScreen || el.webkitRequestFullScreen
                    || el.mozRequestFullScreen || el.msRequestFullscreen
                if (typeof rfs !== 'undefined' && rfs) {
                    rfs.call(el)
                }
                this.isFullScreen = true
            },
            exitFullScreen () {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                }
                this.isFullScreen = false
            },
            imgGroupsWrapperMouseDown (ev) {
                const { openEnlarge, mouseEventObj } = this
                if (!openEnlarge) {
                    return
                }
                const { clientX, clientY } = ev
                mouseEventObj.isPressing = true
                mouseEventObj.startX = clientX
                mouseEventObj.startY = clientY
            },
            imgGroupsWrapperMouseMove (ev) {
                const {
                    openEnlarge, mouseEventObj, enlargePos, enlargeScale
                } = this
                if (!openEnlarge || !mouseEventObj.isPressing || enlargeScale<=1) {
                    return
                }
                const { startX, startY } = mouseEventObj
                const { clientX, clientY } = ev
                enlargePos.x += clientX - startX
                enlargePos.y += clientY - startY

                /*const { groupsTotalWrapper } = this.$refs
                const midWidth = groupsTotalWrapper.clientWidth * ((enlargeScale - 1) / 2)
                const midHeight = groupsTotalWrapper.clientHeight * ((enlargeScale - 1) / 2)

                if (enlargePos.x <= -midWidth) {
                    enlargePos.x = -midWidth
                }
                if (enlargePos.x > midWidth) {
                    enlargePos.x = midWidth
                }
                if (enlargePos.y <= -midHeight) {
                    enlargePos.y = -midHeight
                }
                if (enlargePos.y > midHeight) {
                    enlargePos.y = midHeight
                }*/
                this.postionEnLargePos();

                mouseEventObj.startX = clientX
                mouseEventObj.startY = clientY
            },
            imgGroupsWrapperMouseUp () {
                this.mouseEventObj.isPressing = false
            },
            cateClick (page) {
                this.resetenlargeScale()
                const { showNextImgs } = this
                if (showNextImgs) {
                    if (page % 2 === 0) {
                        this.readingPageIndex = page
                    } else {
                        this.readingPageIndex = page - 1
                    }
                } else {
                    this.readingPageIndex = page
                }
                this.showCateLog = false;
            },
            async getOriginalImgs (page) {
                try {
                    this.isPending = true
                    const { readingPageIndex, totalCount } = this
                    const dataIndex = readingPageIndex - 1
                    const { id, year, issue } = this.$route.params
                    const { Data } = await this.$apis('magazine')
                        .getOriginalImgs(id, year, issue, page)
                    const left = Data.slice(0, 20)
                    const right = Data.slice(20)
                    this.$set(this.originalImgsArrBase, dataIndex, left)
                    this.$set(this.originalImgsArrBase, readingPageIndex, right)
                    if (this.originalImgsArrBase.length > totalCount - 1) {
                        this.originalImgsArrBase = this.originalImgsArrBase.slice(0, totalCount - 1)
                    }
                    this.isPending = false
                } catch (error) {
                    const { Code } = error
                    if (Code === 4) {
                        this.$store.commit('setShowLoginRegister', true)
                    }
                    this.$tools.checkBindMobile(Code);
                    console.log(error)
                }
            },
            async getOriginalCatelog (startPage = 1) {
                try {
                    const { originalCatelog, totalCount } = this
                    if (originalCatelog.length > 0) {
                        startPage = originalCatelog.length + 1
                    }
                    if (startPage > totalCount) {
                        if (this.catelogBScroll) {
                            this.catelogBScroll.finishPullUp()
                        }
                        return
                    }
                    const { id, year, issue } = this.$route.params
                    const { Data } = await this.$apis('magazine')
                        .getOriginalCatelog(id, year, issue, startPage)
                    if (originalCatelog.length > 0) {
                        this.originalCatelog = this.originalCatelog.concat(Data)
                        if (this.originalCatelog > totalCount) {
                            this.originalCatelog = this.originalCatelog.slice(0, totalCount - 1)
                        }
                        this.$nextTick(() => {
                            if (this.catelogBScroll) {
                                this.catelogBScroll.finishPullUp()
                            }
                        })
                        return
                    }
                    Data.shift()
                    this.originalCatelog = Data
                } catch (error) {
                    if (this.catelogBScroll) {
                        this.catelogBScroll.finishPullUp()
                    }
                    console.log(error)
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            next(async (vm) => {
                const { params } = vm.$route
                vm.$store.commit('setPlayerBaseData', undefined)
                vm.$store.commit('setPlayerCateLogList', [])
                vm.$store.commit('setShowPlayingSequence', -1)
                if (vm.$tools.isSameParams(params, vm.lastParams) && vm.originalImgsArrBase[0]) {
                    return
                }

                vm.totalCount = params.count
                vm.readingPageIndex = 2
                vm.lastParams = params
                vm.originalImgsArrBase = []
                vm.originalImgsArrBase.length = params.count - 1
                vm.originalCatelog = []
                vm.isPending = false
                vm.openEnlarge = true
                vm.showScaleGlass = false
                await vm.getMagainzeInfo(params);
                vm.getOriginalCatelog()
            })
        }
    }
</script>

<style lang="scss" scoped>
    .originalReading-view {
        min-width: 1140px;
        position: absolute;
        left: 0;
        top: -120px;
        right: 0;
        bottom: 0;
        background: #fff;
        z-index: 3;
    }

    .originalReading-body-mask {
        height: 100%;
        box-sizing: border-box;
        background: #F0F0F0;
        border-radius: 2px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .groups-total-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: relative;
        overflow: hidden;
    }

    .groups-total-mask {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .img-groups-mask {
        background: #F0F0F0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: flex-start;

        img {
            display: block;
            border: none;
            outline: none;
        }
    }

    .img-groups-mask:nth-child(2) {
        justify-content: flex-start;
    }

    .progress-mask {
        flex: 1;
        height: 3px;
        position: absolute;
        background: #ACD3F1;
        border-radius: 1.5px;

        .percent-mask {
            width: 500px;
            max-width: 100%;
            height: 3px;
            background: #20A0FF;
            border-radius: 1.5px;
        }
    }

    .active-btns {

        div {
            width: 38px;
            position: absolute;
            border: 1px solid #D8D8D8;
            background: #fff;
            cursor: pointer;
            background-position: center center;
            background-repeat: no-repeat;
        }

        .base-btn {
            height: 38px;
            background-size: 16px 16px;
        }

        .back-btn {
            left: -48px;
            top: 50px;
            background-image: url('../../assets/originalReader/exit.png');
        }

        .fullScreen-btn {
            right: -48px;
            top: 50px;
            background-image: url('../../assets/originalReader/fullScreen.png');
        }

        .enlarge-btn {
            right: -48px;
            top: 89px;
            background-image: url('../../assets/originalReader/enlarge.png');
        }
        .ensmall-btn {
            right: -48px;
            top: 126px;
            background-image: url('../../assets/originalReader/ensmall.png');
        }

        .catelog-btn {
            right: -48px;
            top: 165px;
        }

        .page-btn {
            height: 100px;
            right: -48px;
            background-size: 10px 20px;
        }

        .prev-btn {
            top: 50%;
            margin-top: -50px;
            background-image: url('../../assets/originalReader/prev.png');
        }

        .next-btn {
            top: 50%;
            margin-top: 51px;
            background-image: url('../../assets/originalReader/prev.png');
            transform: rotate(180deg);
        }
    }

    .catelog-mask {
        position: absolute;
        right: 0;
        background: #fff;
        overflow: hidden;
        transition: width .5s;
    }

    .catelog-wrapper {
        overflow: hidden;
        box-sizing: border-box;
        border: 1px solid #ccc;
        border-right: none;
    }

    .catelog-content {
        width: 100%;
        box-sizing: border-box;
        padding: 10px 12px;

        img {
            display: block;
            width: 100%;
            margin-bottom: 10px;
            cursor: pointer;
        }
    }

    .scale-glass-mask {
        position: fixed;
        left: 10px;
        top: 10px;
    }

    .glass-view {
        width: 250px;
        height: 250px;
        overflow: hidden;
        border: 1px solid #ccc;
    }

    .glass-total-content {
        background: #F0F0F0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: flex-start;

        img {
            display: block;
            height: 20%;
            border: none;
            outline: none;
        }
    }

    .loader {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: 0.8);
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        transition: opacity 1s;
    }
</style>

<style lang="scss">
.img-groups-mask {

    img {
        user-select: none;
    }
}
</style>
